module.exports = __webpack_public_path__ + "static/media/bell.f3e1419d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/bell.mp3
// module id = 1465
// module chunks = 0